'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dImported from "./presto.-Two-Factor-Auth-View$-Imported.js";
import * as $j_presto$002eui$002etotp$002e$002dMigration$0024 from "./presto.ui.totp.-Migration$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$Imported$() {
}
export { $c_Lpresto_TwoFactorAuthView$Imported$ as $c_Lpresto_TwoFactorAuthView$Imported$ };
$p = $c_Lpresto_TwoFactorAuthView$Imported$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$Imported$;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$Imported$() {
}
export { $h_Lpresto_TwoFactorAuthView$Imported$ as $h_Lpresto_TwoFactorAuthView$Imported$ };
$h_Lpresto_TwoFactorAuthView$Imported$.prototype = $p;
$p.cFn = (function(account) {
  return new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dImported.$c_Lpresto_TwoFactorAuthView$Imported(account.jA, account.GW(), account.GW(), $j_presto$002eui$002etotp$002e$002dMigration$0024.$m_Lpresto_ui_totp_Migration$().csT(account), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
var $d_Lpresto_TwoFactorAuthView$Imported$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$Imported$, "presto.TwoFactorAuthView$Imported$", ({
  TI: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_TwoFactorAuthView$Imported$ as $d_Lpresto_TwoFactorAuthView$Imported$ };
var $n_Lpresto_TwoFactorAuthView$Imported$;
function $m_Lpresto_TwoFactorAuthView$Imported$() {
  if ((!$n_Lpresto_TwoFactorAuthView$Imported$)) {
    $n_Lpresto_TwoFactorAuthView$Imported$ = new $c_Lpresto_TwoFactorAuthView$Imported$();
  }
  return $n_Lpresto_TwoFactorAuthView$Imported$;
}
export { $m_Lpresto_TwoFactorAuthView$Imported$ as $m_Lpresto_TwoFactorAuthView$Imported$ };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$-Imported$.js.map
